import React, { Fragment } from 'react'
import { Text, View, StyleSheet } from '@react-pdf/renderer';

const FlightTableHeader = () => {
    const styles = StyleSheet.create({
        Flightcontainer: {
            flexDirection: 'row',
            backgroundColor: '#E4E4E4',
            alignItems : 'center',
            fontStyle: 'bold',
            paddingBottom : '5px',
            paddingTop : '10px',
            paddingLeft : '15px'
        },
        departure: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        form: {
            width : '15%',
            fontSize : "11px",
            color : "#333333"
        },
        to:{
            width : '15%',
            fontSize : "11px",
            color : "#333333"
        },
        description: {
            width : '20%',
            fontSize : "11px",
            color : "#333333"
        },
        meal: {
            width : '15%',
            fontSize : "11px",
            color : "#333333"
        },
        seat: {
            width : '15%',
            fontSize : "11px",
            color : "#333333"
        }
    });
    return (
        <Fragment>
            <View style={styles.Flightcontainer}>
                <Text style={styles.departure}>Departure Date</Text>
                <Text style={styles.form}>From</Text>
                <Text style={styles.to}>to</Text>
                <Text style={styles.description}>Description</Text>
                <Text style={styles.meal}>Meal</Text>
                <Text style={styles.seat}>Seat</Text>
            </View>
        </Fragment>
    )
}

export default FlightTableHeader